import { render, staticRenderFns } from "./MyList.vue?vue&type=template&id=399d84fa&scoped=true&"
import script from "./MyList.vue?vue&type=script&lang=js&"
export * from "./MyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399d84fa",
  null
  
)

export default component.exports